var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 20.8789L15.6484 16.2306","stroke":"#1E2A67","strokeWidth":"2.51227","key":0}),React.createElement("path",{"d":"M19.1341 12.7429C16.8099 10.4187 13.3236 13.905 15.6478 16.2292","stroke":"#1E2A67","strokeWidth":"2.51227","key":1}),React.createElement("path",{"d":"M19.1344 12.7426C21.4586 15.0668 17.9723 18.553 15.6481 16.2288","stroke":"#1E2A67","strokeWidth":"2.51227","key":2})]);
}

SearchIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
